/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";

var _class, _temp;

import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import * as AssetActions from 'DesignData/actions/finder/Assets';
import * as finderSelectors from 'DesignData/selectors/finder';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FileResults from 'DesignFinderUI/components/results/FileResults';

const i18nKey = key => `DesignFinderUI.results.RecentlyEditedFiles.${key}`;

function mapStateToProps(state) {
  return {
    fetchError: finderSelectors.getRecentlyEditedFetchError(state),
    isFetching: finderSelectors.getIsFetchingRecentlyEdited(state),
    results: finderSelectors.getRecentlyEditedFiles(state)
  };
}

const mapDispatchToProps = {
  fetchRecentlyEdited: AssetActions.fetchRecentlyEdited,
  closeFinderRecentlyEdited: AssetActions.closeRecentlyEdited
};
export default connect(mapStateToProps, mapDispatchToProps)((_temp = _class = class extends Component {
  componentDidMount() {
    this.props.fetchRecentlyEdited();
  }

  render() {
    const {
      isFetching,
      results
    } = this.props;
    return isFetching ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered",
      grow: true
    }) : /*#__PURE__*/_jsx(FileResults, Object.assign({}, this.props, {
      total: results.length,
      emptyText: {
        header: text(i18nKey('results.empty.header')),
        help: text(i18nKey('results.empty.help'))
      },
      headerText: text(i18nKey('header')),
      onClose: this.props.closeFinderRecentlyEdited
    }));
  }

}, _class.propTypes = Object.assign({}, FileResults.propTypes, {
  fetchRecentlyEdited: PropTypes.func.isRequired,
  shouldFetchData: PropTypes.bool
}), _class.defaultProps = Object.assign({}, FileResults.defaultProps), _temp));